import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { HelpCircle, ListOrdered, PenLine, Link2 } from "lucide-react";
import { useI18n } from "@/i18n/i18n";

const Bloque = ({ icon: Icon, title, steps, tip, testId }) => (
  <div className="rounded-xl border border-slate-200 p-4" data-testid={testId}>
    <h4 className="text-sm font-semibold text-slate-900 flex items-center gap-2">
      <Icon className="h-4 w-4 text-brand-blue" /> {title}
    </h4>
    <ol className="mt-2 space-y-1.5 list-decimal list-inside">
      {steps.map((s, i) => (
        <li key={i} className="text-sm text-slate-600">{s}</li>
      ))}
    </ol>
    {tip && <p className="mt-2 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-2.5 py-1.5">{tip}</p>}
  </div>
);

/** Manual corto de las tres actividades, para que el estudiante arranque sin ayuda. */
export const ConjugationGuide = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const lista = (key) => t(key).split(" | ");

  return (
    <>
      <Button size="sm" onClick={() => setOpen(true)} data-testid="conjugation-guide-btn"
              className="bg-emerald-600 hover:bg-emerald-700 text-white shadow-sm">
        <HelpCircle className="h-4 w-4" /> {t("cjg_button")}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="conjugation-guide-dialog">
          <DialogHeader>
            <DialogTitle>{t("cjg_title")}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-slate-600">{t("cjg_intro")}</p>
          <div className="space-y-3 mt-2">
            <Bloque icon={ListOrdered} title={t("cjg_m1_title")} steps={lista("cjg_m1_steps")}
                    tip={t("cjg_m1_tip")} testId="conjugation-guide-mode-forms" />
            <Bloque icon={PenLine} title={t("cjg_m2_title")} steps={lista("cjg_m2_steps")}
                    tip={t("cjg_m2_tip")} testId="conjugation-guide-mode-sentences" />
            <Bloque icon={Link2} title={t("cjg_m3_title")} steps={lista("cjg_m3_steps")}
                    tip={t("cjg_m3_tip")} testId="conjugation-guide-mode-linked" />
          </div>
          <div className="mt-3 rounded-xl bg-slate-50 border border-slate-200 p-4">
            <h4 className="text-sm font-semibold text-slate-900">{t("cjg_extras_title")}</h4>
            <ul className="mt-2 space-y-1.5">
              {lista("cjg_extras").map((s, i) => (
                <li key={i} className="text-sm text-slate-600">· {s}</li>
              ))}
            </ul>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
